import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Estado } from '../../../../shared/shared/estado.enum';
import { ICadastro, ICategoriaVendaOptions, IDealerOptions, IListaAnos, IFamiliaOptions } from '../interface-previsao-venda';
import { ServiceAppService } from '../../../../security/service-app.service';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-previsao-venda-cadastro',
  templateUrl: './previsao-venda-cadastro.component.html',
  styleUrls: ['./previsao-venda-cadastro.component.scss']
})
export class PrevisaoVendaCadastroComponent implements OnInit {
  @Input() cadastro: ICadastro;
  @Input() exibeCadastro: boolean;
  @Input() cadastroTitulo: string;
  @Input() state: Estado;
  @Output() recarregarDados: EventEmitter<any> = new EventEmitter<any>();
  @Output() fecharModalCadastro: EventEmitter<boolean> = new EventEmitter<boolean>();
  isForm: boolean = true;
  submitted: boolean;
  dealerOptions: IDealerOptions[] = [];
  categoriaVendaOptions: ICategoriaVendaOptions[] = [];
  familiaOptions: IFamiliaOptions[] = [];
  listaAnos: IListaAnos[] = [];

  constructor(private service: ServiceAppService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.retornaDropDownListas();
  }

  retornaDropDownListas() {
    this.service.getDados(`/filtro/dealer`).subscribe(res => {
      this.dealerOptions = [];
      res.filtros.forEach(res => this.dealerOptions.push({ id_dealer: res.id, nome_dealer: res.descricao }));
    });

    this.service.getDados(`/filtro/categoria_venda`).subscribe(res => {
      this.categoriaVendaOptions = [];
      res.filtros.forEach(res => this.categoriaVendaOptions.push({ id_categoria_venda: res.id, nome_categoria_venda: res.descricao }));
    });

    this.service.getDados(`/filtro/familia`).subscribe(res => {
      this.familiaOptions = [];
      res.filtros.forEach(res => this.familiaOptions.push({ id_familia: res.id, nome_familia: res.descricao }));
    });

    for (let i = 0; i <= 30; i++) {
      this.listaAnos.push({ descricao: `20${i < 10 ? '0' + i : i}`, ano: 2000 + i });
    }
  }

  isPrevisaoVendaVeiculos(): boolean {
    if (!this.cadastro?.id_categoria_venda) {
      return false;
    }

    const categoriaSelected = this.categoriaVendaOptions.find(cat =>
      cat.id_categoria_venda === this.cadastro.id_categoria_venda
    );

    if (!categoriaSelected) {
      return false;
    }

    // Verifica se a categoria contém "veículos" no nome (case insensitive)
    return categoriaSelected.nome_categoria_venda.toLowerCase().includes('previsão vendas veículos') ||
      categoriaSelected.nome_categoria_venda.toLowerCase().includes('previsão vendas veiculos');
  }
  
  onTipoPrevisaoChange() {
    // Limpa o campo família quando trocar o tipo de previsão
    if (!this.isPrevisaoVendaVeiculos()) {
      this.cadastro.id_veiculos = null;
    }
  }

  saveDados() {
    this.submitted = true;

    // Validação adicional para família quando for previsão venda veículos
    if (this.isPrevisaoVendaVeiculos() && !this.cadastro.id_veiculos) {
      this.messageService.add({
        key: 'previsao-venda',
        severity: 'error',
        summary: 'Erro',
        detail: 'Família é obrigatória para Previsão Venda Veículos',
        life: 3000
      });
      return;
    }

    // Se não for previsão venda veículos, garantir que id_veiculos seja null
    if (!this.isPrevisaoVendaVeiculos()) {
      this.cadastro.id_veiculos = null;
    }

    if (this.isForm) {
      this.cadastro.mes = this.cadastro.mesDate.getMonth() + 1;
      delete this.cadastro.mesDate;
    }

    let listaCadastros: any[] = [];

    if (this.cadastro.todosDealer) {
      this.service.getDados("/filtro/dealer").subscribe(res => {
        res.filtros.forEach(item => {
          let novoCadastro = { ...this.cadastro }; // Cria uma nova instância do objeto cadastro
          delete novoCadastro.todosDealer;
          novoCadastro.id = item.id;
          listaCadastros.push(novoCadastro);
        });

        this.aplicaSaveDados(listaCadastros);
      });

    } else {
      delete this.cadastro.todosDealer;
      listaCadastros.push(this.cadastro);
      this.aplicaSaveDados(listaCadastros);
    }

    this.exibeCadastro = false;
  }

  aplicaSaveDados(dados: ICadastro[]) {
    const isInsert = this.state === Estado.insert;
    const pathRequest = isInsert ? '/previsaoVenda/insereRegistro' : '/previsaoVenda/alteraRegistro';
    const message = isInsert ? 'Cadastro realizado com sucesso!' : 'Alteração realizada com sucesso!';

    let request;

    if (isInsert) {
      const listaCadastros = { dados };
      request = this.service.postDados(pathRequest, listaCadastros);
    } else {
      // Realiza a requisição PUT com os dados já existentes no this.cadastro
      request = this.service.putDados(pathRequest, this.cadastro);
    }

    request.subscribe(
      res => {
        this.messageService.add({
          key: 'previsao-venda',
          severity: 'success',
          summary: 'Sucesso',
          detail: message,
          life: 3000
        });
        this.recarregarDados.emit();
      },
      error => {
        this.messageService.add({
          key: 'previsao-venda',
          severity: 'error',
          summary: 'Erro',
          detail: error.erro,
          life: 3000
        });
        this.recarregarDados.emit();
      }
    );
  }

  uploader(event) {
    const json = this.convertExcelToJson(event);
  }

  convertExcelToJson(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.files[0];

    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.insertArquivo(JSON.stringify(jsonData));
    }
    reader.readAsBinaryString(file);
  }

  insertArquivo(json) {
    var row = JSON.parse(json)
    var verifica = this.verificaArquivo(row);
    if (verifica) {
      let listaCadastros = [];
      for (let i = 0; i < row.NBS.length; i++) {
        if (typeof row.NBS[i].dealer === "undefined" || typeof row.NBS[i].categoria === "undefined" || typeof row.NBS[i].mes === "undefined" || typeof row.NBS[i].ano === "undefined" || typeof row.NBS[i].valor === "undefined" || typeof row.NBS[i].monetario === "undefined") {
          alert('Arquivo com erro na linha ' + (i + 2));
        } else {
          let novoCadastro = { ...this.cadastro };
          novoCadastro.id = 0; // Será 0 para que o backend use buscarDealer
          // Para uploads de arquivo, vamos criar um objeto que o backend possa processar
          let dadosUpload = {
            ...novoCadastro,
            id_dealer: row.NBS[i].dealer.toString(), // Código do dealer para busca
            id_categoria_venda: parseInt(row.NBS[i].categoria),
            mes: parseInt(row.NBS[i].mes),
            ano: parseInt(row.NBS[i].ano),
            valor: parseFloat(row.NBS[i].valor),
            tipo_valor: row.NBS[i].monetario.toString(),
            id_veiculos: null // Inicializar como null
          };
          // Adiciona família se estiver presente no arquivo
          if (row.NBS[i].familia) {
            dadosUpload.id_veiculos = parseInt(row.NBS[i].familia);
          }
          listaCadastros.push(dadosUpload);
        }
      }
      this.aplicaSaveDados(listaCadastros);
      this.exibeCadastro = false;
    }
  }

  verificaArquivo(row) {
    var teste = [];
    for (let i = 0; i < row.NBS.length; i++) {
      teste.push(row.NBS[i].dealer?.toString() + row.NBS[i].categoria?.toString() + row.NBS[i].mes?.toString() + row.NBS[i].ano?.toString());
    }
    if (!this.hasDuplicates(teste)) {
      return true;
    } else {
      const mensagem = 'Arquivo Com Itens Duplicados';
      this.messageService.add({ key: 'previsao-venda', severity: 'error', summary: 'Erro', detail: mensagem, life: 3000 });
    }

  }

  hasDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }

  hideDialog() {
    this.isForm = true;
    this.exibeCadastro = false;
    this.fecharModalCadastro.emit(this.exibeCadastro);
  }

  alteraFormulario() {
    this.isForm = !this.isForm;
  }
}